<template>
  <div>
    <SideBar :bar_name="tabName" :user="user" />
    <v-main>
      <v-container>
        <NetworkShop v-bind="{ user, tabName: 'Line User ร้านค้าเครือข่าย' }" />
      </v-container>
    </v-main>
  </div>
</template>

<script>
import SideBar from "@/components/SideBar";
import NetworkShop from "@/components/ChangTT/NetworkShop.vue";

export default {
  name: "CTTNetworkShop",
  components: {
    SideBar,
    NetworkShop,
  },
  data() {
    return {
      user: this.$user,
      tabName: "Chang TT Network Shop",
    };
  },
};
</script>
